import Router from "./routes";
import { useEffect, useState } from "react";
import ThemeProvider from "./theme";
import ScrollToTop from "./components/scroll-to-top";
import { StyledChart } from "./components/chart";
import LoginPage from "./pages/LoginPage";
import { useSearchParams } from "react-router-dom";
import { AuthProvider } from './AuthContext';
import axios from "axios";

export default function App() {
  const [searchParams] = useSearchParams();
  const [showLogin, setShowLogin] = useState(false);
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      axios.defaults.headers.common["authorization"] = token;
    }
    if (!token && !searchParams.has("token")) {
      setShowLogin(true);
    }
  }, [searchParams]);

  if (showLogin) {
    return (
      <ThemeProvider>
        <LoginPage />
      </ThemeProvider>
    );
  }
  return (
    <ThemeProvider>
      <ScrollToTop />
      <StyledChart />
      <AuthProvider>
        <Router />
      </AuthProvider>
    </ThemeProvider>
  );
}
